export default "__VITE_ASSET__4b42e89b__"